/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Loan_chip from "./components/Loan_chip";

/* Section heading with an "Edit" shortcut back to the stage that owns the data */
const SectionHeader = ({ title, onEdit }) => (
  <div className="flex items-center justify-between gap-3 mb-4">
    <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
    <button
      type="button"
      onClick={onEdit}
      title={`Edit ${title}`}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-green-700 bg-green-50 border border-green-200 rounded-full hover:bg-green-100 hover:border-green-300 focus:outline-none transition-colors"
    >
      <FaPencilAlt size={11} />
      Edit
    </button>
  </div>
);

const ReadField = ({ label, value }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <input type="text" readOnly value={value || "N/A"}
      className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm cursor-not-allowed" />
  </div>
);

function Preview() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { GetFormOneAppliedLoanTemp, ResetUserDataResponse } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [formState] = useState(6);

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const user = useSelector((state) => state?.auth?.user);
  // Matches LoanDetailed and Guarantor: the staff form never collects
  // affordability, or a mandate number and OTP for the applicant or either
  // guarantor, so the preview must not offer them back as empty rows.
  const isStaff = user?.user_type === "STAFF";
  const userData = useSelector((state) => state?.user);
  const { loanTemp } = userData;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  // Jump back to the stage that owns a section so it can be corrected.
  // The stage pages reload the saved draft, so the entered data is preserved.
  const goToStage = (path) => history.push(path);

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
  }, []);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      ResetUserDataResponse();
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-personal_info");
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state, response?.message, response?.action]);

  return (
    <div className="ApplyLoans">
      <RenderHome title="Apply Loan">
        {isLoading && <Loader />}

        <Loan_chip formState={formState} />

        <div style={{ maxWidth: "800px", margin: "0 auto", padding: "0 1rem 2rem" }}>

          {/* Personal Information */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Personal Information" onEdit={() => goToStage("/apply-loan-personal_info")} />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Full Name" value={user?.name} />
              <ReadField label="Date of Birth" value={loanTemp?.dateOfBirth} />
              <ReadField label="Age" value={loanTemp?.age?.toString()} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="SSNIT" value={loanTemp?.ssnit} />
              <ReadField label="ID Type" value={loanTemp?.IdCardType} />
              <ReadField label="ID Number" value={loanTemp?.IDCardNumber} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Gender" value={loanTemp?.gender} />
              <ReadField label="Region" value={loanTemp?.region} />
              <ReadField label="Sector" value={loanTemp?.sector} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <ReadField label="Residential Address (Line 1)" value={loanTemp?.residential_address1} />
                <div className="mt-2"><ReadField label="Line 2" value={loanTemp?.residential_address2} /></div>
              </div>
              <div>
                <ReadField label="Work Address (Line 1)" value={loanTemp?.work_address1} />
                <div className="mt-2"><ReadField label="Line 2" value={loanTemp?.work_address2} /></div>
              </div>
            </div>
          </div>

          {/* Contact Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Contact Details" onEdit={() => goToStage("/apply-loan-personal_info")} />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <ReadField label="Phone Number" value={loanTemp?.personal_phone} />
              <ReadField label="Work Phone" value={loanTemp?.work_phone} />
              <ReadField label="Email Address" value={loanTemp?.email} />
            </div>
          </div>

          {/* Guarantor 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Guarantor 1" onEdit={() => goToStage("/apply-loan-guarantor")} />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Name" value={loanTemp?.guarantor_name} />
              <ReadField label="Staff ID" value={loanTemp?.guarantor_staff_id} />
              <ReadField label="Phone" value={loanTemp?.guarantor_phone} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Ghana Card" value={loanTemp?.guarantor_ghana_card} />
              <ReadField label="GPS Address" value={loanTemp?.guarantor_gps} />
              <ReadField label="Occupation" value={loanTemp?.guarantor_occupation} />
            </div>
            <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4`}>
              {!isStaff && (
                <>
                  <ReadField label="Mandate Number" value={loanTemp?.guarantor_mandate_number} />
                  <ReadField label="OTP Number" value={loanTemp?.guarantor_otp_number?.toString()} />
                </>
              )}
              <ReadField label="Relationship" value={loanTemp?.guarantor_relationship} />
            </div>
          </div>

          {/* Guarantor 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Guarantor 2" onEdit={() => goToStage("/apply-loan-guarantor")} />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Name" value={loanTemp?.guarantor_name2} />
              <ReadField label="Staff ID" value={loanTemp?.guarantor_staff_id2} />
              <ReadField label="Phone" value={loanTemp?.guarantor_phone2} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Ghana Card" value={loanTemp?.guarantor_ghana_card2} />
              <ReadField label="GPS Address" value={loanTemp?.guarantor_gps2} />
              <ReadField label="Occupation" value={loanTemp?.guarantor_occupation2} />
            </div>
            <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4`}>
              {!isStaff && (
                <>
                  <ReadField label="Mandate Number" value={loanTemp?.guarantor_mandate_number2} />
                  <ReadField label="OTP Number" value={loanTemp?.guarantor_otp_number2?.toString()} />
                </>
              )}
              <ReadField label="Relationship" value={loanTemp?.guarantor_relationship2} />
            </div>
          </div>

          {/* Employment Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Employment Details" onEdit={() => goToStage("/apply-loan-employment")} />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <ReadField label="Employer" value={loanTemp?.employer_name} />
              <ReadField label="Facility" value={loanTemp?.facility} />
              <ReadField label="Staff ID" value={user?.staff_id} />
            </div>
            <div className="mt-4">
              <ReadField label="Employment Start Date" value={loanTemp?.employment_start_date} />
            </div>
          </div>

          {/* Loan Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Loan Details" onEdit={() => goToStage("/apply-loan-loan_detailed")} />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Loan Amount (&#8373;)" value={loanTemp?.loanAmount?.toString()} />
              {!isStaff && (
                <ReadField label="Affordability (&#8373;)" value={loanTemp?.affordability?.toString()} />
              )}
              <ReadField label="Monthly Deduction (&#8373;)" value={loanTemp?.monthlyDeduction?.toString()} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <ReadField label="Loan Term (months)" value={loanTemp?.loanTerm?.toString()} />
              {!isStaff && (
                <>
                  <ReadField label="Mandate Number" value={loanTemp?.mandateNumber} />
                  <ReadField label="OTP Number" value={loanTemp?.otpNumber?.toString()} />
                </>
              )}
            </div>
            <ReadField label="Purpose of Loan" value={loanTemp?.purposeForLoan} />
          </div>

          {/* Bank Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Bank Details" onEdit={() => goToStage("/apply-loan-loan_detailed")} />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <ReadField label="Account Holder" value={loanTemp?.bank_account_holder_name} />
              <ReadField label="Bank Name" value={loanTemp?.bank_name} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <ReadField label="Account Number" value={loanTemp?.bank_account_number} />
              <ReadField label="Bank Branch" value={loanTemp?.bank_branch} />
            </div>
          </div>

          {/* Uploaded Documents — always rendered so its Edit button stays
              reachable, which matters most when nothing has been uploaded. */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <SectionHeader title="Uploaded Documents" onEdit={() => goToStage("/apply-loan-uploads")} />
            {loanTemp?.frontIDImage || loanTemp?.passportImage ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {loanTemp?.frontIDImage && (
                  <div className="border rounded-lg p-3">
                    <p className="text-sm font-medium text-gray-700 mb-2">Ghana Card (Front)</p>
                    <img src={loanTemp.frontIDImage} alt="front-id" className="w-full h-44 object-contain rounded-md" />
                  </div>
                )}
                {loanTemp?.passportImage && (
                  <div className="border rounded-lg p-3">
                    <p className="text-sm font-medium text-gray-700 mb-2">Ghana Card (Back)</p>
                    <img src={loanTemp.passportImage} alt="back-id" className="w-full h-44 object-contain rounded-md" />
                  </div>
                )}
              </div>
            ) : (
              <p className="text-sm text-gray-500">
                No documents uploaded yet. Use Edit to add your Ghana Card.
              </p>
            )}
          </div>

          <div className="flex justify-between mt-2">
            <button type="button"
              onClick={() => history.push("/apply-loan-uploads")}
              className="px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none">
              Back
            </button>
            <button type="button"
              onClick={() => history.push("/apply-loan-terms")}
              className="px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none">
              Next
            </button>
          </div>

        </div>
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default Preview;
